<template>
  <div>
    <div class="dropbox" style="height: 100%">
      <input
        type="file"
        multiple
        :name="uploadFieldName"
        :disabled="isSaving"
        @change="filesChange($event.target.files)"
        accept="application/pdf, image/*"
        class="input-file"
        ref="inputFile"
      />
      <p><v-icon>mdi-cloud-upload-outline</v-icon>Vybrať súbor na nahratie</p>
    </div>
    <span v-for="(file, index) of filesToUpload" :key="index">
      <div class="uploaded-file">
        <v-icon>mdi-image-outline</v-icon>
        <div class="upload-progress-container">
          <div class="upload-filename">{{ file.name }}</div>
          <v-progress-linear
            height="6"
            rounded
            background-opacity="1"
            :value="uploadProgress"
          ></v-progress-linear>
          <div class="upload-progress-size">
            {{ calcSize(file.size) }} MB z {{ Number((file.size / (1024 * 1024)).toFixed(1)) }} MB
          </div>
        </div>

        <v-btn icon @click="removeFile(file)">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </div>
    </span>
    <div class="negative500 mt-10px ml-5px" style="font-size: 16px" v-if="errorMessage">
      {{ errorMessage }}
    </div>
  </div>
</template>

<script>
import protectedAxios from '../../auth/axios';
import utils from '../../plugins/utils';

const STATUS_INITIAL = 0,
  STATUS_SAVING = 1,
  STATUS_SUCCESS = 2,
  STATUS_FAILED = 3;

export default {
  name: 'app',
  data() {
    return {
      uploadError: null,
      uploadProgress: 0,
      uploadProgressSize: [],
      fileSizeAllFiles: 0,
      currentStatus: null,
      uploadFieldName: 'file_name',
      filesToUpload: [],
      errorMessage: null,
      onFilesSaved: null,
      onfilesNotSaved: null,
    };
  },
  computed: {
    isInitial() {
      return this.currentStatus === STATUS_INITIAL;
    },
    isSaving() {
      return this.currentStatus === STATUS_SAVING;
    },
    isSuccess() {
      return this.currentStatus === STATUS_SUCCESS;
    },
    isFailed() {
      return this.currentStatus === STATUS_FAILED;
    },
  },
  methods: {
    calcSize(val) {
      return Number((val / (1024 * 1024)) * (this.uploadProgress / 100)).toFixed(1);
    },
    reset() {
      // reset form to initial state
      this.currentStatus = STATUS_INITIAL;
      this.uploadedFiles = [];
      this.uploadError = null;
    },
    save(
      idTypuDokumentu,
      poznamka,
      newId,
      cisoloDokladu,
      cisloLZ,
      cisloPredmetu,
      idZastupcu,

    ) {
      // upload data to the server
      this.currentStatus = STATUS_SAVING;
      const formData = new FormData();

      const config = {
        'Content-Type': 'multipart/form-data',
        onUploadProgress: progressEvent => {
          this.uploadProgress = Math.round((progressEvent.loaded * 100) / progressEvent.total);
        },
      };
      if (this.filesToUpload.length <= 0) {
        this.errorMessage = 'Zadajte súbory pre upload.';
        this.onfilesNotSaved();
        this.$refs.inputFile.value = '';
        this.currentStatus = STATUS_FAILED;
        return;
      }
      if (idTypuDokumentu <= 0) {
        this.errorMessage = 'Zadajte prosím typ dokumentu.';
        this.onfilesNotSaved();
        this.$refs.inputFile.value = '';
        this.currentStatus = STATUS_FAILED;
        return;
      }
      for (var i = 0; i < this.filesToUpload.length; i++) {
        let file = this.filesToUpload[i];
        formData.append('Files', file); //naplnime formData suborom
      }

      formData.append('ID_Zastupcu', idZastupcu ?? -1);
      formData.append('ID_Dokumentu', -1);
      formData.append('ID_Skupiny', 1);
      formData.append('ID_Typu', idTypuDokumentu); //128
      formData.append('Cislo_lz', '');
      formData.append('Cislo_Dokladu', cisoloDokladu ?? '');
      formData.append('Cislo_lz', cisloLZ ?? '');
      formData.append('Cislo_Obch_Pripadu', '');
      formData.append('poznamka', poznamka ?? '');
      formData.append('cislo_predmetu', cisloPredmetu ?? 0);
      formData.append('new_id', newId ?? utils.GuidEmpty());
      this.errorMessage = null;
      //console.warn(cisloPredmetu);
      protectedAxios
        .post('dms/upload', formData, config)
        .then(response => {
          if (!Object.keys(response.data).length == 0) {
            //this.errorMessage = response.data;
            this.currentStatus = STATUS_FAILED;
            this.onfilesNotSaved();
            console.warn(response.data);

            this.errorMessage = response.data;

            //console.warn('problem upload ');
          } else if (this.onFilesSaved) {
            this.onFilesSaved();
            this.filesToUploadLength = this.filesToUpload.length;
            for (var i = 0; i < this.filesToUploadLength; i++) {
              this.removeFile(0);
            }
            this.$refs.inputFile.value = '';
            this.currentStatus = STATUS_SUCCESS;
            this.$emit('uploaded');
          }
        })
        .catch(e => {
          console.error(e);
          this.errorMessage = e;
          this.onfilesNotSaved();
        });
    },
    saveotp(otp) {
      // upload data to the server - s login guid a pin pre one time password od zakaznika externe bez loginu
      this.currentStatus = STATUS_SAVING;
      const formData = new FormData();
      if (this.filesToUpload.length <= 0) {
        this.errorMessage = 'Zadajte súbory pre upload.';
        this.$refs.inputFile.value = '';
        this.onfilesNotSaved();
        this.currentStatus = STATUS_FAILED;
        return;
      }
      const config = {
        'Content-Type': 'multipart/form-data',
        onUploadProgress: progressEvent => {
          this.uploadProgress = Math.round((progressEvent.loaded * 100) / progressEvent.total);
        },
      };
      for (var i = 0; i < this.filesToUpload.length; i++) {
        let file = this.filesToUpload[i];
        formData.append('Files', file); //naplnime formData suborom
      }
      formData.append('ID_Dokumentu', -1);
      formData.append('ID_Skupiny', 1);
      //formData.append('ID_Typu', 128);
      formData.append('Cislo_lz', '');
      formData.append('Cislo_Dokladu', '');
      formData.append('Cislo_Obch_Pripadu', '');
      //poznamka sa nastavuje na serverovej casti v pripade OTP
      formData.append('guidOtp', otp.guid);
      formData.append('pinOtp', otp.pin);
      this.errorMessage = null;

      protectedAxios
        .post('dms/uploadotp', formData, config)
        .then(response => {
          if (!Object.keys(response.data).length == 0) {
            console.warn(response.data);
            this.errorMessage = response.data;
            this.currentStatus = STATUS_FAILED;
            this.onfilesNotSaved();
            //console.warn('problem upload ');
          } else if (this.onFilesSaved) {
            this.onFilesSaved();
            this.filesToUploadLength = this.filesToUpload.length;
            for (var i = 0; i < this.filesToUploadLength; i++) {
              this.removeFile(0);
            }
            this.$refs.inputFile.value = '';
            //console.warn('inputFile cleared');
            //console.warn(this.filesToUpload.length);
            this.currentStatus = STATUS_SUCCESS;
            //this.$emit('uploaded');
          }
        })
        .catch(e => {
          console.error(e);
          this.errorMessage = e;
          this.onfilesNotSaved();
        });
    },
    filesSaved(onFilesSaved) {
      this.onFilesSaved = onFilesSaved;
    },
    filesNotSaved(onfilesNotSaved) {
      this.onfilesNotSaved = onfilesNotSaved;
    },
    removeFile(fileindex) {
      this.filesToUpload.splice(fileindex, 1);
    },

    filesChange(fileList) {
      // handle file changes

      if (!fileList.length) return;
      this.errorMessage = '';

      this.filesToUpload = Array.from(fileList);
    },
  },

  mounted() {
    this.reset();
  },
};
</script>
